export default function initPopup() {
  Alpine.data('popup', () => ({
    open: false,
    activeCookieName: '',
    activeCookieExpires: '',

    init() {
      const cookieName = this.$el.getAttribute('data-cookie-name');
      const cookieExpires = this.$el.getAttribute('data-cookie-expires');

      if (!cookieName || !cookieExpires || this.hasCookie(cookieName)) {
        return;
      }

      this.activeCookieName = cookieName;
      this.activeCookieExpires = cookieExpires;

      queueMicrotask(() => {
        this.open = true;
      });
    },

    close() {
      this.open = false;
      if (this.activeCookieName) {
        this.setSeenCookie(this.activeCookieName, this.activeCookieExpires);
      }
    },

    setSeenCookie(name: string, expires: string) {
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      const expireDate = new Date(expires).toUTCString();
      document.cookie = `${encodeURIComponent(name)}=1; expires=${expireDate}; path=/; SameSite=Lax${secure}`;
    },

    hasCookie(name: string) {
      const encodedName = `${encodeURIComponent(name)}=`;
      return document.cookie.split('; ').some((cookie) => cookie.trim().startsWith(encodedName));
    },
  }));
}